import React, { useEffect, useState } from "react";
import { Image } from "antd";
import { parseFirebaseDateTime } from "../../../utils/helper";
import { MESSAGE_TYPES } from "../../../utils/constants";
import useAWSUpload from "../../../hooks/useAWSUpload";

const MessageRow = ({ message, visitor, searchMsg }) => {
  const [getSignedUrl] = useAWSUpload();
  const [url, setUrl] = useState(null);
  const imageFormats = ["JPEG", "JPG", "PNG", "GIF", "BMP", "TIFF", "JFIF"];
  const lastDotIndex = message?.key?.lastIndexOf(".");
  const fileExtension = message?.key?.substring(lastDotIndex + 1).toUpperCase();

  const isFormatExists = imageFormats.includes(fileExtension);

  useEffect(() => {
    if (message.type === MESSAGE_TYPES.attachment) renderSignedUrl();
  }, []);
  const renderSignedUrl = async () => {
    setUrl(await getSignedUrl(message.key));
  };

  const renderLog = () => {
    if (visitor) {
      return (
        <div className="alert_msg">
          <div className="alerts">
            <p>{message.body}</p>
          </div>
          <p
            title={parseFirebaseDateTime(message.created_at, "datetime")}
            className="time"
          >
            {parseFirebaseDateTime(message.created_at, "time")}
          </p>
        </div>
      );
    }
  };

  let element = document.getElementById(searchMsg);
  element?.scrollIntoView({ behavior: "smooth" });
  const renderMessage = () => {
    const regex =
      /(https?:\/\/(?:www.)?[-a-zA-Z0-9@:%_.+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&//=]*))/gi;
    if (regex.test(message.body)) {
      const msg = message.body.replace(
        /(https?:\/\/(?:www.)?[-a-zA-Z0-9@:%_.+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&//=]*))/gi,
        (suburl) => {
          return "<a href=" + suburl + " target='_blank'>" + suburl + "</a>";
        }
      );
      return (
        <>
          <div dangerouslySetInnerHTML={{ __html: msg }}></div>
        </>
      );
    }
    const renderMessage = message.body
      ?.split("\n")
      ?.filter((line) => line !== "") // Filter out empty lines
      ?.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index !== message.length - 1 && <br />}{" "}
          {/* Render <br /> except for the last line */}
        </React.Fragment>
      ));
    return renderMessage;
  };

  switch (message.type) {
    case MESSAGE_TYPES.navigation:
      return (
        <div className="alert_msg">
          <div className="alerts">
            <p>
              {visitor.name ? visitor.name : visitor.visitor_default} Navigated
              to
              <a
                href={message.body}
                target="_blank"
                style={{ marginLeft: "5px" }}
              >
                {message.body}
              </a>
            </p>
          </div>
          <p
            title={parseFirebaseDateTime(message.created_at, "datetime")}
            className="time"
          >
            {parseFirebaseDateTime(message.created_at, "time")}
          </p>
        </div>
      );
    case MESSAGE_TYPES.activity:
      return (
        <div className="alert_msg">
          <div className="alerts">
            <p>{message.body}</p>
          </div>
          <p
            title={parseFirebaseDateTime(message.created_at, "datetime")}
            className="time"
          >
            {parseFirebaseDateTime(message.created_at, "time")}
          </p>
        </div>
      );
    case MESSAGE_TYPES.log:
      return renderLog();

    default:
      return (
        <div
          className={`flex_between ${
            message.isVisitor ? "visitor_msg " : "agent_msg"
          }`}
        >
          <div id={message.id}>
            {message.isVisitor ? (
              <h3>{visitor.name ? visitor.name : visitor.visitor_default}</h3>
            ) : (
              <h3>{message.name}</h3>
            )}
            <p
              style={{
                backgroundColor: `${message.id === searchMsg ? "yellow" : ""}`,
              }}
            >
              {message.type === MESSAGE_TYPES.attachment ? (
                <>
                  {isFormatExists ? (
                    <div
                      style={{
                        margin: "10px 0",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Image src={url} width={200} />
                      <a href={url} target="_blank">
                        {message.body}
                      </a>
                    </div>
                  ) : (
                    <a href={url} target="_blank">
                      {message.body}
                    </a>
                  )}
                </>
              ) : (
                <div>{renderMessage()}</div>
              )}
            </p>
          </div>
          <div className="time_msg">
            <p
              title={parseFirebaseDateTime(message.created_at, "datetime")}
              className="time"
            >
              {message?.readStatus === 1 && !message?.isVisitor && (
                <i
                  className="fa-solid fa-check-double"
                  style={{ color: "#1677ff" }}
                ></i>
              )}
              {message?.readStatus !== 1 &&
                !message?.isVisitor &&
                message?.delivered && (
                  <i
                    className="fa-solid fa-check-double"
                    style={{ color: "gray" }}
                  ></i>
                )}

              {message?.readStatus !== 1 &&
                !message?.delivered &&
                !message?.isVisitor && (
                  <i
                    className="fa-solid fa-check"
                    style={{ color: "black" }}
                  ></i>
                )}

              {parseFirebaseDateTime(message.created_at, "time")}
            </p>
          </div>
        </div>
      );
  }
};

export default MessageRow;
